module.exports = __webpack_public_path__ + "static/img/2.6991065.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/2.png
// module id = vP4J
// module chunks = 0